import { render, staticRenderFns } from "./ApiTester.vue?vue&type=template&id=40448957&scoped=true&"
import script from "./ApiTester.vue?vue&type=script&lang=js&"
export * from "./ApiTester.vue?vue&type=script&lang=js&"
import style0 from "./ApiTester.vue?vue&type=style&index=0&id=40448957&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40448957",
  null
  
)

export default component.exports